
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Cliente } from 'src/app/model/cliente';


const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  @Injectable({
    providedIn: 'root'
  })
  export class ClienteService {
    private url : string = `${environment.HOST}/api/cliente`;
  


    constructor(
        private http : HttpClient,
        private router : Router
      ) { }

   

   
    
      
    
  nuevoCliente( nombre : string, apellido : string,movil : string,passe : string,codigoCliente : string,correo : string) {
    return this.http.post(`${this.url}/nuevo-cliente/${nombre}/${apellido}/${movil}/${passe}/${codigoCliente}/${correo}`, "");
  }





    }